import { useQuery } from 'react-query'
import { QUERY_KEYS } from 'src/constants'

import { scanToEarnService } from 'src/services/scan-to-earn.service'

export const useGetConsumerScan = (id: string, enabled: boolean) => {
  return useQuery(
    [QUERY_KEYS.CONSUMER_SCAN_ITEM, id],
    () => scanToEarnService.getConsumerScan(id),
    {
      keepPreviousData: true,
      enabled,
      staleTime: 5 * 60 * 1000,
    },
  )
}
